// // src/components/DiningSectionSimple.js
// import { Link } from "react-router-dom";

// const DiningSectionSimple = () => {
//   return (
//     <section
//       className="relative min-h-[600px] 2xl:h-[650px] backgroundattachment md:py-0 py-6 bg-cover flex items-center justify-center text-center text-white"
//       style={{
//         backgroundImage:
//           "url('https://res.cloudinary.com/dgwnm39m7/image/upload/v1772531148/WhatsApp_Image_2026-03-03_at_2.43.55_PM_kfa29h.jpg')",
//           backgroundPosition:"50% 50%"
//       }}
//     >
//       {/* Dark Overlay */}
//       <div className="absolute inset-0 bg-black/50"></div>

//       {/* Content */}
//       <div className="relative z-10 max-w-4xl px-6">
//         <h2 className="text-4xl lg:text-5xl font-light mb-5 leading-tight">
//           Dining, Shopping & Entertainment {" "}
//           <span className="font-bold text-[#c9a86c] mt-2 block">All in One Place</span>
//         </h2>

//         {/* First Paragraph */}
//         <p className="md:text-[17px] 2xl:text-lg mb-5 text-gray-200 animate-fade-in-up animation-delay-400 leading-relaxed">
//           At <span className="font-semibold text-white">StayIN Hospitality</span>, everything you need is just steps away. Located inside The Centaurus Mall, our guests enjoy easy access to a wide range of cafés, restaurants, and the famous Centaurus Food Court offering delicious local and international food options.
//         </p>

//                         {/* Second Paragraph - Mövenpick */}
//                         <p className="md:text-[17px] 2xl:text-lg mb-5 text-gray-200 animate-fade-in-up animation-delay-400 leading-relaxed">
//           For a more refined dining experience, the nearby Mövenpick Hotel Centaurus Islamabad offers specialty Thai, Chinese, Japanese, Oriental dishes and BBQ buffet selections — perfect for family dinners and business meetings.
//         </p>

//         {/* Third Paragraph - Shopping & Entertainment */}
//         <p className="md:text-[17px] 2xl:text-lg mb-6 text-gray-200 animate-fade-in-up animation-delay-400 leading-relaxed">
//           You can also explore premium shopping brands, lifestyle stores, and a modern cinema — all under one roof.
//         </p>

//         <Link
//           to="/contact"
//           className="bg-[#c9a86c] text-white px-8 py-4 rounded-full font-medium hover:bg-[#b38f5a] transition-all duration-300 inline-flex items-center gap-2 justify-center group"
//         >
//           Contact us
//         </Link>
//       </div>
//     </section>
//   );
// };

// export default DiningSectionSimple;






// src/components/DiningSectionSimple.js
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const DiningSectionSimple = () => {
  return (
    <>
      {/* SEO Meta Tags */}
      <Helmet>
        <title>Dining, Shopping & Entertainment | Centaurus Mall Islamabad | StayIN</title>
        <meta name="description" content="Enjoy premium dining, shopping & entertainment at Centaurus Mall Islamabad. Located inside the mall, StayIN guests have easy access to restaurants, food court, Mövenpick Hotel & cinema." />
        <meta name="keywords" content="Centaurus Mall Islamabad, dining Centaurus, Mövenpick Hotel Islamabad, shopping Islamabad, StayIN dining, Centaurus food court" />
      </Helmet>

      <section
        className="relative min-h-[600px] 2xl:h-[650px] backgroundattachment md:py-0 py-6 bg-cover flex items-center justify-center text-center text-white"
        style={{
          backgroundImage:
            "url('https://res.cloudinary.com/dgwnm39m7/image/upload/v1772531148/WhatsApp_Image_2026-03-03_at_2.43.55_PM_kfa29h.jpg')",
          backgroundPosition:"50% 50%"
        }}
        aria-label="Dining, shopping and entertainment at Centaurus Mall Islamabad"
      >
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black/50"></div>

        {/* Content */}
        <div className="relative z-10 max-w-4xl px-6">
          <h2 className="text-4xl lg:text-5xl font-light mb-5 leading-tight">
            Dining, Shopping & Entertainment{" "}
            <span className="font-bold text-[#c9a86c] mt-2 block">All in One Place</span>
          </h2>

          {/* First Paragraph */}
          <p className="md:text-[17px] 2xl:text-lg mb-5 text-gray-200 animate-fade-in-up animation-delay-400 leading-relaxed">
            At <span className="font-semibold text-white">StayIN Hospitality</span>, everything you need is just steps away. Located inside The Centaurus Mall, our guests enjoy easy access to a wide range of cafés, restaurants, and the famous Centaurus Food Court offering delicious local and international food options.
          </p>

          {/* Second Paragraph - Mövenpick */}
          <p className="md:text-[17px] 2xl:text-lg mb-5 text-gray-200 animate-fade-in-up animation-delay-400 leading-relaxed">
            For a more refined dining experience, the nearby Mövenpick Hotel Centaurus Islamabad offers specialty Thai, Chinese, Japanese, Oriental dishes and BBQ buffet selections — perfect for family dinners and business meetings.
          </p>

          {/* Third Paragraph - Shopping & Entertainment */}
          <p className="md:text-[17px] 2xl:text-lg mb-6 text-gray-200 animate-fade-in-up animation-delay-400 leading-relaxed">
            You can also explore premium shopping brands, lifestyle stores, and a modern cinema — all under one roof.
          </p>

          <Link
            to="/contact"
            className="bg-[#c9a86c] text-white px-8 py-4 rounded-full font-medium hover:bg-[#b38f5a] transition-all duration-300 inline-flex items-center gap-2 justify-center group"
            aria-label="Contact StayIN for dining and accommodation inquiries at Centaurus Islamabad"
          >
            Contact us
          </Link>
        </div>
      </section>
    </>
  );
};

export default DiningSectionSimple;